/**
 * filter-criteria-specs.js
 */

import { Types } from 'utils/constants';

export const FilterCriteriaSpecs = [
  {
    // Empty criteria
    isEmpty: true,
    'fieldType': Types.FilterCriteriaField.DROPDOWN,
    'type': ' ',
    'title': '',
    'values': [
      { 'id': 0, val: '' },
    ]
  },
  {
    'fieldType': Types.FilterCriteriaField.DROPDOWN,
    'type': 'complete',
    'title': 'Completed',
    'group': Types.RecordGroup.ALL,
    'groupTitle': 'Common Criteria',
    'values': [
      { 'id': 1, 'val': 'Complete' },
      { 'id': 0, 'val': 'Not Complete' }
    ],
  },
  {
    'fieldType': Types.FilterCriteriaField.DROPDOWN,
    'type': 'reviewStatus',
    'title': 'Review Status',
    'group': Types.RecordGroup.ALL,
    'groupTitle': 'Common Criteria',
    'values': [
      { 'id': Types.ReviewStatus.NOT_REVIEWED, 'val': 'Not Reviewed' },
      { 'id': Types.ReviewStatus.ACCEPTED, 'val': 'Accepted' },
      { 'id': Types.ReviewStatus.REJECTED, 'val': 'Rejected' },
    ],
  },
  {
    'fieldType': Types.FilterCriteriaField.DROPDOWN,
    'type': 'environmentType',
    'title': 'Environment Type',
    'group': Types.RecordGroup.ALL,
    'groupTitle': 'Common Criteria',
    'workMode': Types.WorkMode.DETECTION,
    'values': [],
  },
  {
    'fieldType': Types.FilterCriteriaField.TEXT,
    'type': 'name',
    'title': 'Title/Name/Case',
    'group': Types.RecordGroup.ALL,
    'groupTitle': 'Common Criteria',
    'values': [''],
  },
  {
    'fieldType': Types.FilterCriteriaField.TEXT,
    'type': 'location',
    'title': 'Location/Address',
    'group': Types.RecordGroup.ALL,
    'groupTitle': 'Common Criteria',
    'values': [''],
  },
  {
    'fieldType': Types.FilterCriteriaField.TEXT,
    'type': 'comments',
    'title': 'Notes',
    'group': Types.RecordGroup.ALL,
    'groupTitle': 'Common Criteria',
    'values': [''],
  },
  {
    'fieldType': Types.FilterCriteriaField.DROPDOWN,
    'type': 'odorType',
    'title': 'Odor Type',
    'group': Types.RecordGroup.ALL,
    'groupTitle': 'Common Criteria',
    'workMode': Types.WorkMode.DETECTION,
    'values': [],
    'linkedType': 'odorSubType',
  },
  {
    'fieldType': Types.FilterCriteriaField.DROPDOWN2,
    'isSecondaryField': true,
    'type': 'odorSubType',
    'title': 'Odor SubType',
    'values': [],
  },
  {
    'fieldType': Types.FilterCriteriaField.DROPDOWN,
    'isBoolean': true,
    'type': 'outdated',
    'title': 'Outdated',
    'group': Types.RecordGroup.TRAINING,
    'groupTitle': 'Training Specific',
    'values': [
      { 'id': 1, 'val': 'Outdated' },
      { 'id': 0, 'val': 'Not Outdated' },
    ],
  },
  {
    'fieldType': Types.FilterCriteriaField.DROPDOWN,
    'isBoolean': true,
    'type': 'blind',
    'title': 'Blind',
    'group': Types.RecordGroup.TRAINING,
    'groupTitle': 'Training Specific',
    'values': [
      { 'id': 1, 'val': 'Yes' },
      { 'id': 0, 'val': 'No' },
    ],
  },
  {
    'fieldType': Types.FilterCriteriaField.DROPDOWN,
    'isBoolean': true,
    'type': 'controlledNegative',
    'title': 'Controlled Negative',
    'group': Types.RecordGroup.TRAINING,
    'groupTitle': 'Training Specific',
    'values': [
      { 'id': 1, 'val': 'Yes' },
      { 'id': 0, 'val': 'No' },
    ],
  },
  {
    'fieldType': Types.FilterCriteriaField.TEXT,
    'type': 'goalDescription',
    'title': 'Goal or Description',
    'group': Types.RecordGroup.TRAINING,
    'groupTitle': 'Training Specific',
    'values': [''],
  },
  {
    'fieldType': Types.FilterCriteriaField.TAG,
    'type': 'eventTags',
    'title': 'Event Tags',
    'group': Types.RecordGroup.TRAINING,
    'groupTitle': 'Training Specific',
    'values': [],
    'anyTagOption': { 'id': 'any', 'val': '<ANY TAG>' }
  },
  {
    'fieldType': Types.FilterCriteriaField.TEXT,
    'type': 'trainerComments',
    'title': 'Trainer Comments',
    'group': Types.RecordGroup.TRAINING,
    'groupTitle': 'Training Specific',
    'values': [''],
  },
  {
    'fieldType': Types.FilterCriteriaField.DROPDOWN,
    'type': 'requestingUnit',
    'title': 'Requesting Unit/Agency',
    'group': Types.RecordGroup.DEPLOYMENT,
    'groupTitle': 'Deployment Specific',
    'values': [],
  },
  {
    'fieldType': Types.FilterCriteriaField.TAG,
    'type': 'deploymentTags',
    'title': 'Deployment Tags',
    'group': Types.RecordGroup.DEPLOYMENT,
    'groupTitle': 'Deployment Specific',
    'values': [],
    'anyTagOption': { 'id': 'any', 'val': '<ANY TAG>' }
  },
  {
    'fieldType': Types.FilterCriteriaField.DROPDOWN,
    'isBoolean': true,
    'type': 'currencyNotIndicated',
    'title': 'Currency Not Indicated',
    'group': Types.RecordGroup.DEPLOYMENT,
    'groupTitle': 'Deployment Specific',
    'workMode': Types.WorkMode.DETECTION,
    'values': [
      { 'id': 1, 'val': 'Yes' },
      { 'id': 0, 'val': 'No' },
    ],
  },
  {
    'fieldType': Types.FilterCriteriaField.DROPDOWN,
    'isBoolean': true,
    'type': 'peopleFound',
    'title': 'People Found',
    'group': Types.RecordGroup.DEPLOYMENT,
    'groupTitle': 'Deployment Specific',
    'workMode': Types.WorkMode.PATROL,
    'values': [
      { 'id': 1, 'val': 'Yes' },
      { 'id': 0, 'val': 'No' },
    ],
  },
  {
    'fieldType': Types.FilterCriteriaField.DROPDOWN,
    'isBoolean': true,
    'type': 'arrests',
    'title': 'Arrests',
    'group': Types.RecordGroup.DEPLOYMENT,
    'groupTitle': 'Deployment Specific',
    'values': [
      { 'id': 1, 'val': 'Yes' },
      { 'id': 0, 'val': 'No' },
    ],
  },
  {
    'fieldType': Types.FilterCriteriaField.DROPDOWN,
    'isBoolean': true,
    'type': 'arrestsWithBites',
    'title': 'Arrests With Bites',
    'group': Types.RecordGroup.DEPLOYMENT,
    'groupTitle': 'Deployment Specific',
    'values': [
      { 'id': 1, 'val': 'Yes' },
      { 'id': 0, 'val': 'No' },
    ],
  },
  {
    'fieldType': Types.FilterCriteriaField.DROPDOWN,
    'isBoolean': true,
    'type': 'unintentionalBites',
    'title': 'Unintentional Bites',
    'group': Types.RecordGroup.DEPLOYMENT,
    'groupTitle': 'Deployment Specific',
    'workMode': Types.WorkMode.PATROL,
    'values': [
      { 'id': 1, 'val': 'Yes' },
      { 'id': 0, 'val': 'No' },
    ],
  },
  {
    'fieldType': Types.FilterCriteriaField.DROPDOWN,
    'type': 'vetVisitCareType',
    'title': 'Care Type',
    'group': Types.RecordGroup.VET_VISIT,
    'groupTitle': 'Vet Visit Specific',
    'values': [],
  },  
];


export const useFilterCriteriaSpecs = (t = null, options = null) => {

  // Reuse the initial criteria object
  let specs = FilterCriteriaSpecs;

  if (!t) {
    return specs;
  }

  // Update spec with translated patrol types
  let patrolTypeCriteria = specs.find(e => e.type === 'patrolType');
  if (patrolTypeCriteria) {
    patrolTypeCriteria.values = Types.Patrol.entries(t)
      .map(({id, name}) => ({ id, val: name }));
  }

  // Update spec with translated environment types
  let envTypeCriteria = specs.find(e => e.type === 'environmentType');
  if (envTypeCriteria) {
    envTypeCriteria.values = Types.Environment.entries(t)
      .map(({id, name}) => ({ id, val: name }));
  }

  // Update spec with translated odor types
  let odorTypeCriteria = specs.find(e => e.type === 'odorType');
  if (odorTypeCriteria) {
    odorTypeCriteria.values = Types.OdorPrimary.entries(t)
      .map(({id, name}) => ({ id, val: name }));
  }

  // Update spec with user's custom entries retrieved from the server
  if (options) {
    // Event tags
    let eventTagCriteria = specs.find(e => e.type === 'eventTags');
    if (eventTagCriteria && options.eventTags) {
      eventTagCriteria.values.length = 0;
      eventTagCriteria.values.push(eventTagCriteria.anyTagOption);
      options.eventTags.map(e => eventTagCriteria.values.push({'id': e.id, 'val': e.name}));
    }

    // Deployment tags
    let deploymentTagCriteria = specs.find(e => e.type === 'deploymentTags');
    if (deploymentTagCriteria && options.deploymentTags) {
      deploymentTagCriteria.values.length = 0;
      deploymentTagCriteria.values.push(deploymentTagCriteria.anyTagOption);
      options.deploymentTags.map(e => deploymentTagCriteria.values.push({'id': e.id, 'val': e.name}));
    }

    // Requesting units
    let reqUnits = specs.find(e => e.type === 'requestingUnit');
    if (reqUnits && options.requestingUnits) {
      reqUnits.values.length = 0;
      options.requestingUnits.map(e => reqUnits.values.push({'id': e.id, 'val': e.name}));
    }

    // Odor subtypes
    let odorSubTypes = specs.find(e => e.type === 'odorSubType');
    if (odorSubTypes && options.odorTypes) {
      const sortedOdorTypeOptions = options.odorTypes.sort((a, b) => a.id < b.id ? -1 : 1);
      odorSubTypes.values.length = 0;
      odorSubTypes.values.push([{ 'id': 0, 'val': '' }]);
      sortedOdorTypeOptions.map(odorType => {
        const subTypes = odorType.subTypes.reduce((acc, curr) =>
          acc.concat({'id': curr.id, 'val': curr.name}), [{ 'id': 0, 'val': '<Any>' }]);
        return odorSubTypes.values.push(subTypes);
      });
    }

    // Vet Visit care types
    const vetVisitCareTypes = specs.find(e => e.type === 'vetVisitCareType');
    if (vetVisitCareTypes && options.vetVisitCareTypes) {
      vetVisitCareTypes.values.length = 0;
      options.vetVisitCareTypes.map(e => vetVisitCareTypes.values.push({'id': e.id, 'val': e.name}));
    }
  }

  return specs;
};
